import { baseApi } from '@/shared/apis'
import { EntityId } from '@reduxjs/toolkit'

import { Scenario } from '../models/planning/Scenario'
import { SaveScenarioPayload } from '../models/SaveScenarioPayload'

// TODO: Deprecate the use of RTK Query and use Redux Thunk instead.
export const planningApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    saveScenario: builder.mutation<Scenario, SaveScenarioPayload>({
      query: (formValues) => ({
        url: '/planning/saveScenario',
        method: 'POST',
        body: formValues,
      }),
    }),
    deleteScenario: builder.mutation<void, EntityId>({
      query: (scenarioId) => ({
        url: '/planning/deleteScenario/',
        method: 'POST',
        body: scenarioId,
      }),
    }),
  }),
})

export const {
  useSaveScenarioMutation,
  useDeleteScenarioMutation,
} = planningApi
